if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.submitButton.disabled) {
          console.log('Button is disabled, ignoring click');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Always request cart-icon-bubble section for immediate icon update
        const sectionsToRequest = ['cart-icon-bubble'];
        if (this.cart) {
          const cartSections = this.cart.getSectionsToRender().map((section) => section.id);
          sectionsToRequest.push(...cartSections);
          this.cart.setActiveElement(document.activeElement);
        }
        formData.append('sections', sectionsToRequest.join(','));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // On product pages, always open cart drawer after adding to cart (exactly like bundle page)
              // Use async/await pattern like bundle page
              (async () => {
                try {
                  // Find cart drawer (same as bundle page)
                  const isMobile = window.matchMedia('(max-width: 600px)').matches;
                  const cartDrawer = !isMobile ? document.querySelector('cart-drawer') : null;
                  
                  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                    let payload = response;
                    
                    // Fallback: if sections are missing, fetch them explicitly (same as bundle page)
                    if (!payload.sections || !payload.sections['cart-drawer']) {
                      const sectionsRes = await fetch('/cart?sections=cart-drawer,cart-icon-bubble', {
                        method: 'GET',
                        headers: { 'Accept': 'application/json' },
                        credentials: 'same-origin'
                      });
                      if (sectionsRes.ok) {
                        const sectionsJson = await sectionsRes.json();
                        payload = { sections: sectionsJson };
                      }
                    }
                    
                    // Render contents - this automatically opens the drawer (same as bundle page)
                    cartDrawer.renderContents(payload);
                    // Ensure drawer is not marked empty after first add (same as bundle page)
                    cartDrawer.classList.remove('is-empty');
                  }
                } catch (drawerError) {
                  console.error('Cart drawer refresh error:', drawerError);
                }
              })();
              
              CartPerformance.measure("add:paint-updated-sections", () => {
                // Performance measurement
              });
              
              // Ensure cart icon bubble is updated
              if (response.sections && response.sections['cart-icon-bubble']) {
                const cartIconBubble = document.getElementById('shopify-section-cart-icon-bubble');
                if (cartIconBubble) {
                  cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // Always re-enable the button after submission completes
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
